import React from 'react';
import { Link } from 'react-router-dom';
import cx from 'classnames';

import Dropdown from 'components/Dropdown';


export const MenuItem = React.forwardRef((p, ref) => {
  let { children, ...props } = p;
  return <a className="menu-item" {...props} ref={ref}>{children}</a>;
});

export const Menu = ({ name, target, className, position = 'bottom right', children, ...props}) => {
  return (
    <Dropdown 
      name={name}
      className={cx("g-menu", className)}
      target={({className,...props}) => 
        target?.({ 
          className: cx('g-menu-target', className), 
          ...props,
        })}
      position={position}>
      <div className="menu-wrap">
        { children }
      </div>
    </Dropdown>)
  
}
export default Menu